import { Controller } from "@hotwired/stimulus"
import currency from "currency.js"

export default class extends Controller {
  connect() {
    this.element.addEventListener("blur", this.format)
  }

  disconnect() {
    this.element.removeEventListener("blur", this.format)
  }

  format = () => {
    const value = this.normalizedValue
    if (!value || !/^-?\d+(?:\.\d*)?$/.test(value)) return

    this.element.value = currency(value, { separator: "'", symbol: "" }).format()
    this.dispatch("formatted", { detail: { value: this.element.value } })
  }

  get normalizedValue() {
    return this.element.value
      .trim()
      .replace(/[’'\s]/g, "")
      .replace(/,(?=[^,]*$)/, ".")
      .replace(/[.](?=.*[.])/g, "")
  }
}
